import _ from 'underscore';
import PerformanceMetricsColumns from '../common-columns/performance-metrics-columns';
import PhonePerformanceMetricsColumns from '../common-columns/phone-performance-metrics-columns';
import SOVColumns from '../common-columns/sov-columns';
import SOVLostColumns from '../common-columns/sov-lost-columns';
import AudienceSOVColumns from '../common-columns/audience-sov-columns';
import QualityScoreColumns from '../common-columns/quality-score-columns';

export function getName() {
  return 'PortfolioBidStrategyGrid';
}

export function getColumnsMetadata() {
  return _.defaults(
    {
      // key is UI column name, value is MT OData property name
      PortfolioGridBidStrategyName: 'Name',
      BidStrategyType: 'Type',
      BidStrategyStatus: 'Status',
      AssociatedCampaigns: 'AssociationCount',
      BidStrategyTargetCpa: 'TargetCpa',
      BidStrategyTargetRoas: 'TargetRoas',
      BidStrategyTargetImpressionShare: 'TargetImpressionShare',
    },
    PerformanceMetricsColumns,
    PhonePerformanceMetricsColumns,
    SOVColumns,
    SOVLostColumns,
    QualityScoreColumns,
    AudienceSOVColumns
  );
}

